import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import BookingWidget from '../components/BookingWidget';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'Όλες' },
    { id: 'exterior', label: 'Εξωτερικός' },
    { id: 'bedroom', label: 'Υπνοδωμάτια' },
    { id: 'kitchen', label: 'Κουζίνα' },
    { id: 'living', label: 'Σαλόνι' },
    { id: 'bathroom', label: 'Μπάνιο' },
    { id: 'fitness', label: 'Fitness' },
    { id: 'moments', label: 'Moments' },
  ];

  const photos = [
    { src: '/images/exterior.jpg', cat: 'exterior' },
    { src: '/images/garden.jpg', cat: 'exterior' },
    { src: '/images/veranda.jpg', cat: 'exterior' },
    { src: '/images/bedroom1.jpg', cat: 'bedroom' },
    { src: '/images/bedroom2.jpg', cat: 'bedroom' },
    { src: '/images/bedroom3.jpg', cat: 'bedroom' },
    { src: '/images/bedroom4.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra1.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra2.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra3.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra4.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra5.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra6.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra7.jpg', cat: 'bedroom' },
    { src: '/images/bed_extra8.jpg', cat: 'bedroom' },
    { src: '/images/kitchen.jpg', cat: 'kitchen' },
    { src: '/images/kitchen2.jpg', cat: 'kitchen' },
    { src: '/images/kitchen3.jpg', cat: 'kitchen' },
    { src: '/images/kitchen4.jpg', cat: 'kitchen' },
    { src: '/images/kitchen5.jpg', cat: 'kitchen' },
    { src: '/images/kitchen6.jpg', cat: 'kitchen' },
    { src: '/images/livingroom.jpg', cat: 'living' },
    { src: '/images/livingroom2.jpg', cat: 'living' },
    { src: '/images/bathroom1.jpg', cat: 'bathroom' },
    { src: '/images/bathroom2.jpg', cat: 'bathroom' },
    { src: '/images/bathroom3.jpg', cat: 'bathroom' },
    { src: '/images/bathroom4.jpg', cat: 'bathroom' },
    { src: '/images/fitness1.jpg', cat: 'fitness' },
    { src: '/images/fitness2.jpg', cat: 'fitness' },
    { src: '/images/moment1.jpg', cat: 'moments' },
    { src: '/images/moment2.jpg', cat: 'moments' },
    { src: '/images/moment3.jpg', cat: 'moments' },
    { src: '/images/moment4.jpg', cat: 'moments' },
    { src: '/images/moment5.jpg', cat: 'moments' },
    { src: '/images/moment6.jpg', cat: 'moments' },
    { src: '/images/moment7.jpg', cat: 'moments' },
    { src: '/images/moment8.jpg', cat: 'moments' },
    { src: '/images/moment9.jpg', cat: 'moments' },
  ];

  const filtered = activeCategory === 'all' ? photos : photos.filter(p => p.cat === activeCategory);

  const handlePrev = (e) => {
    e.stopPropagation();
    setSelectedIndex(i => (i - 1 + filtered.length) % filtered.length);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setSelectedIndex(i => (i + 1) % filtered.length);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowLeft') setSelectedIndex(i => (i - 1 + filtered.length) % filtered.length);
    if (e.key === 'ArrowRight') setSelectedIndex(i => (i + 1) % filtered.length);
    if (e.key === 'Escape') setSelectedIndex(null);
  };

  return (
    <div data-testid="gallery-page" className="min-h-screen pt-24 pb-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <p className="uppercase tracking-widest text-xs text-[#D4A72C] mb-4">Villa Aristotle</p>
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#1E3A5F] mb-6">{t("gallery.title")}</h1>
        <p className="text-[#1E3A5F]/70 text-lg max-w-2xl">{t("gallery.subtitle")}</p>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <div className="flex flex-wrap gap-2">
          {categories.map(cat => (
            <button key={cat.id} onClick={() => setActiveCategory(cat.id)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${activeCategory === cat.id ? 'bg-[#1E3A5F] text-white' : 'bg-[#1E3A5F]/10 text-[#1E3A5F] hover:bg-[#1E3A5F]/20'}`}>
              {cat.label}
            </button>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {filtered.map((photo, i) => (
            <div key={i} onClick={() => setSelectedIndex(i)} className="overflow-hidden rounded-sm cursor-pointer group h-[200px]">
              <img src={photo.src} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
            </div>
          ))}
        </div>
      </div>
      {selectedIndex !== null && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedIndex(null)}
          onKeyDown={handleKeyDown}
          tabIndex={0}
          autoFocus
        >
          <button
            onClick={handlePrev}
            className="absolute left-4 md:left-8 text-white bg-black/40 hover:bg-black/70 rounded-full w-12 h-12 flex items-center justify-center text-2xl transition-colors z-10"
          >
            ‹
          </button>
          <img
            src={filtered[selectedIndex].src}
            alt=""
            className="max-h-[90vh] max-w-[90vw] rounded shadow-xl"
            onClick={e => e.stopPropagation()}
          />
          <button
            onClick={handleNext}
            className="absolute right-4 md:right-8 text-white bg-black/40 hover:bg-black/70 rounded-full w-12 h-12 flex items-center justify-center text-2xl transition-colors z-10"
          >
            ›
          </button>
          <button
            onClick={() => setSelectedIndex(null)}
            className="absolute top-4 right-4 text-white bg-black/40 hover:bg-black/70 rounded-full w-10 h-10 flex items-center justify-center text-xl transition-colors z-10"
          >
            ×
          </button>
        </div>
      )}
      <BookingWidget variant="sticky" />
    </div>
  );
};

export default Gallery;
